/******************************************************************************************
 *	Blackout Error
 *******************************************************************************************
 *
 * The `Blackout Error` is an error modal that covers the entire content between header and footer.
 * All interaction is blocked until the issue at hand, the one that caused the blackout error to appear, is resolved.
 *
 */
(function() {


  angular
    .module('rcServices.blackoutError', [])
    .service(
      'BlackoutError',
      /* @ngInject */
      function($rootScope, Redirector) {
        var DEFAULT_ICON = 'icon-dataunavailable';

        var self = this;

        var applyChanges = function() {
          if (!$rootScope.$$phase) {
            $rootScope.$apply();
          }
        };

        //Active status
        var isActive = false;
        this.isActive = function() {
          return isActive;
        };

        this.show = function(config) {
          if (config && config.title && config.message) {
            isActive = true;

            this.title = config.title;
            this.message = config.message;
            this.icon = config.icon || DEFAULT_ICON;
            this.actionLabel = config.actionLabel;
            this.actionFunction = config.actionFunction;
            this.hideHeaderContents = config.hideHeaderContents || false;
            this.hideHeaderDrawer = config.hideHeaderDrawer || false;
            this.hideFooterContents = config.hideFooterContents || false;

            applyChanges();
          }
        };
        this.hide = function() {
          isActive = false;
          applyChanges();
        };

        //Sugar
        //Generic App Failure
        this.showGenericError = function() {
          var config = {
            title: 'blackoutError.generic.title',
            message: 'blackoutError.generic.message',
            icon: 'icon-close-circle',
            actionLabel: 'blackoutError.generic.actionLabel',
            actionFunction: function() {
              //Reload the current page, without using the cache.
              document.location.reload(true);
            },
            hideHeaderContents: true
          };
          self.show(config);
        };

        //Language Pack Error
        this.showLanguagePackError = function() {
          var config = {
            title: 'Language Pack Error',
            message: 'I’m sorry, but for some reason, no language packs could be loaded.',
            icon: 'icon-globeremove',
            actionLabel: 'Reload',
            actionFunction: function() {
              //Reload the current page, without using the cache.
              document.location.reload(true);
            },
            hideHeaderContents: true,
            hideFooterContents: true
          };
          self.show(config);
        };

        //Revoked or expired invitations error
        this.showExpiredInvitationError = function() {
          var config = {
            title: 'blackoutError.expiredInvitation.title',
            message: 'blackoutError.expiredInvitation.message',
            icon: 'icon-emailcancel'
          };
          self.show(config);
        };

        //Valid user credentials, but invalid RC user
        this.showUnauthorizedUserError = function() {
          var config = {
            title: 'blackoutError.unauthorizedUser.title',
            message: 'blackoutError.unauthorizedUser.message',
            icon: 'icon-lockon',
            actionLabel: 'blackoutError.unauthorizedUser.actionLabel',
            actionFunction: function() {
              Redirector.go('logout', true);
            }
          };
          self.show(config);
        };

        //Valid user credentials, but JIL authorization call failed
        this.showAuthorizationFailError = function() {
          var config = {
            title: 'blackoutError.authorizationFailure.title',
            message: 'blackoutError.authorizationFailure.message',
            icon: 'icon-lockon',
            actionLabel: 'blackoutError.authorizationFailure.actionLabel',
            actionFunction: function() {
              Redirector.go('logout', true);
            }
          };
          self.show(config);
        };

        //Cookies Disabled (which means local and session storage unavailable)
        this.showCookiesDisabledError = function() {
          var config = {
            title: 'blackoutError.cookiesDisabled.title',
            message: 'blackoutError.cookiesDisabled.message',
            icon: 'icon-globeremove',
            hideHeaderDrawer: true
          };
          self.show(config);
        };
      }
    )
    .directive(
      'rcBlackoutError',
      /* @ngInject */
      function(BlackoutError) {
        return {
          restrict: 'A',
          replace: true,
          scope: {},
          templateUrl: 'templates/blackout-error.html',
          link: function(scope) {
            scope.BlackoutError = BlackoutError;
          }
        };
      }
    );
})();
